import { useStore } from "@/store";
const store = useStore();
import { GeneralActionTypes } from "@/store/modules/general/action-types";
let tempData: string | any[] = [];

const data = {
  filter: {
    title: "assetsfilter",
    pageName: "assetsfilter",
    genre: "assetPageFilter",
    hideFilter: true,
    filters: [
    ],
  },
  header: {
    navigation: [
      {
        title: "endpoints",
        icon: "drak_computer",
        url: "computers/all",
      },
      {
        title: "browseassets",
        icon: "breadcrumb",
        url: "",
      },
      {
        title: "usersbycomputer",
        icon: "group",
        url: "users-by-computers",
      },
    ],
    buttonPosition: "pr-4 justify-content-between",
    buttons: [
      // {
      //   title: "manage",
      //   icon: "manage",
      //   link: "/assets/manage",
      //   class: "primary",
      //   target: "",
      //   toggle: "",
      // },
      // {
      //   title: "export",
      //   icon: "export",
      //   link: "/assets/manage",
      //   class: "secondary",
      //   target: "",
      //   toggle: "",
      // },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "companyname",
          field: "companySiteOrGroupName",
          sortable: true,
          components: [
            {
              component: "rowRouter",
              key: "companySiteOrGroupGuid",
              route: function (row: any) {
                const url = `/endpoints/company/${row.companySiteOrGroupGuid}/sites`;
                return url;
              },
              displayField: "companySiteOrGroupName",
            },
          ],
        },
        {
          label: "totalLicenceCount",
          field: "totalLicenceCount",
          format: 'number',
          sortable: true,
          jsSort: true
        },
        {
          label: "usedLicenceCount",
          field: "usedLicenceCount",
          format: 'number',
          sortable: true,
          jsSort: true
        },
        {
          label: "sitescount",
          field: "siteCount",
          format: 'number',
          sortable: true,
          jsSort: true
        },
        {
          label: "groupscount",
          field: "groupCount",
          format: 'number',
          sortable: true,
          jsSort: true
        },
        {
          label: "computerCount",
          field: "computerCount",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "offlinemachines",
          field: "offlineMachines",
          sortable: true,
          format: 'number',
          jsSort: true,
        },
        {
          label: "unresolvedAlerts",
          field: "unresolvedAlerts",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "eventsPerDay",
          field: "eventsPerDay",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "blocksPerComputer",
          field: "blocksPerComputer",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "malicioushashes",
          field: "maliciousHashes",
          format: 'number',
          sortable: true,
          jsSort: true,
        },
        {
          label: "eventcount",
          field: "eventCount",
          sortable: true,
          format: 'number'
          // display: function (row: any) {
          //   return '<a href="#" class="name-btn">' + row.eventCount + "</a>";
          // },
        },
        // {
        //   label: "malicioushashes",
        //   field: "malicioushashes",
        //   sortable: false,
        //   display: function (row: any) {
        //     return (
        //       '<a href="#" class="name-btn">' + row.malicioushashes + "</a>"
        //     );
        //   },
        // },
      ],
      rows: [],
      allRows: [],
      total: 0,
      sortable: {
        order: "WindowsComputerName",
        sort: "asc",
      },
      page: 1,
      pageSize: 10,
      isLoading: true,
      fetchTable: async (options: any) => {
        if (tempData.length === 0) {
          tempData = options.allRows;
        }
        const page = options.page;
        const pageSize = options.pageSize;
        const data = tempData.slice((page - 1) * pageSize, page * pageSize);

        (options || {}).rows = data;
      },
    },
  },
};

export default data;
